import { ACTIVITY_STATUSES, type ActivityStatusValue } from './activity.js';

/** `all` = every status except archived (same as the Activities list API). */
export const ACTIVITY_OVERVIEW_STATUS_FILTERS = [...ACTIVITY_STATUSES, 'all'] as const;
export type ActivityOverviewStatusFilter = (typeof ACTIVITY_OVERVIEW_STATUS_FILTERS)[number];

export type ActivityOverviewStatusCounts = Record<ActivityStatusValue, number> & { total: number };

export interface ActivityOverviewDomainStyle {
  fillColor: string;
  strokeColor: string;
}

export interface ActivityOverviewHealth {
  total: number;
  noImage: number;
  noPreference: number;
  noPack: number;
  noPlayType: number;
  /** Every skill on the activity is owned by another domain. */
  noPrimarySkill: number;
}

export interface ActivityOverviewSkill {
  id: number;
  title: string;
  /** Activities whose primary domain owns this skill. */
  primaryCount: number;
  /** Activities in other primary domains that use this skill. */
  crossDomainCount: number;
}

export interface ActivityOverviewDimension {
  id: number;
  title: string;
  activityCount: number;
}

/** Dense, same order as the matching top-level dimension list. */
export interface ActivityOverviewCount {
  id: number;
  activityCount: number;
}

export interface ActivityOverviewDomain {
  id: number;
  key: string;
  level: number;
  title: string;
  style: ActivityOverviewDomainStyle | null;
  activityCount: number;
  skills: ActivityOverviewSkill[];
  preferenceCounts: ActivityOverviewCount[];
  packCounts: ActivityOverviewCount[];
  playTypeCounts: ActivityOverviewCount[];
  health: ActivityOverviewHealth;
}

export interface ActivityOverviewResponse {
  status: ActivityOverviewStatusFilter;
  /** Unfiltered, includes archived. */
  statusCounts: ActivityOverviewStatusCounts;
  /** Activities matching the status filter. */
  totalActivities: number;
  /** Matching activities whose primary domain is null or soft-deleted. */
  noActiveDomainCount: number;
  preferences: ActivityOverviewDimension[];
  packs: ActivityOverviewDimension[];
  playTypes: ActivityOverviewDimension[];
  health: ActivityOverviewHealth;
  domains: ActivityOverviewDomain[];
}
